import React, { FC } from 'react';
import { productAgeEnum } from '../../enums/productAge.enum';
import { Slider, styled, useMediaQuery } from '@material-ui/core';

interface AgeSliderProps {
  value: number;
  onChange: (value: number | number[]) => void;
  ref?: any;
  id?: string;
  disabled?: boolean;
}

const IOSSlider = styled(Slider)(({ theme }) => ({
  color: '#ec672b',
  height: 5,
  padding: '15px 0',
  '& .MuiSlider-thumb': {
    height: 35,
    width: 60,
    borderRadius: 18,
    backgroundColor: '#fff',
    marginTop: -16,
    marginLeft: -22.5,
    border: '1px solid #ec672b',
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.1)',
    },
    '&:before': {
      boxShadow:
        '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
    },
    '&[aria-valuenow="5"]': {
      marginLeft: '-60px !important',
    },
    '&[aria-valuenow="1"]': {
      marginLeft: '0 !important',
    }
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 14,
    fontWeight: 'bold',
    top: 11,
    left: 8,
    backgroundColor: 'unset',
    color: theme.palette.text.primary,
    '&::before': {
      display: 'none',
    },
    '& *': {
      background: 'transparent',
      color: '#000',
      width: 40,
      textAlign: 'center',
    },
  },
  '& .MuiSlider-track': {
    border: 'none',
    height: 3.5,
  },
  '& .MuiSlider-rail': {
    opacity: 1,
    height: 3.5,
    boxShadow: 'inset 0px 0px 4px -2px #000',
    backgroundColor: '#ec672b',
  },
  '& .MuiSlider-mark': {
    height: 14,
    width: 14,
    top: 10,
    opacity: 1,
    borderRadius: 99,
    backgroundColor: '#ec672b',

    '&[data-index="4"]': {
      left: '98% !important',
    }
  },
  '&.isMobile .MuiSlider-mark[data-index="4"]': {
    left: '96% !important'
  },
}));

const AgeSlider: FC<AgeSliderProps> = ({ref, value, onChange, id, disabled = false}) => {
  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down('sm'));

  const valueLabelFormat = (value: number) => {
    return productAgeEnum[value];
  }

  return (
    <IOSSlider
      ref={ref}
      id={id}
      value={value}
      onChange={(event, value) => onChange(value)}
      aria-labelledby="discrete-slider"
      valueLabelFormat={valueLabelFormat}
      getAriaValueText={valueLabelFormat}
      disabled={disabled}
      step={1}
      marks
      min={1}
      max={5}
      valueLabelDisplay="on"
      className={isMobile ? 'isMobile' : ''}
    />
  );
}

export default AgeSlider;
